import * as React from 'react';
import { PurchaseItem } from '../PurchaseItem';
import * as styles from './styles.css';
import { IPurchase } from '../../../../types/purchase';

interface IContainerProps {
  list: IPurchase[];
  onOpenModal(item: IPurchase): void;
}

export function PurchaseList({ list, onOpenModal }: IContainerProps) {
  return (
    <ul className={styles['container']}>
      {list.map(item => (
        <li className={styles['item']} key={item.step} onClick={() => onOpenModal(item)}>
          <PurchaseItem step={item.step} title={item.title} />
        </li>
      ))}
    </ul>
  );
}
